module.exports = __webpack_public_path__ + "media/images/gray_star-0449eef8e9741eac9b3047cc24387b8a.svg";